import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// monkey patches nonce to inline style elements
(window.document as any).originalCreateElement = window.document.createElement;
// weird prettier asking for a dot
// eslint-disable-next-line
window.document.createElement = function(
  tagName: string,
  options: ElementCreationOptions
) {
  const newElement = (window.document as any).originalCreateElement(
    tagName,
    options
  );
  if (tagName === 'style') {
    const nonce = document
      .querySelector('meta[name="csp-nonce"]')
      ?.getAttribute('content');
    nonce != undefined && newElement.setAttribute('nonce', nonce);
  }
  return newElement;
};

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err)); // eslint-disable-line
